import { useState } from 'react'

import { useDebounce, useSetState } from '@domain-group/react-hooks'

import useBrandProvider from '@hooks/useBrandProvider'
import useSelector from '@hooks/useSelector'

import { BrandProviderModel } from '@models/types'

const defaultState = {
  string: '',
}

const useBulkCreateBrandProviderModal = (brandProvider: Partial<BrandProviderModel> = {}) => {
  const { brand_id, provider_id } = brandProvider

  const [selectedEntityIds, setSelectedEntityIds] = useState<number[]>([])

  const [state, setState] = useSetState(defaultState)
  const { string } = state

  const {
    brand,
    callbacks: { bulkCreateBrandProviders },
    creating,
    provider,
  } = useBrandProvider(brandProvider)

  const debouncedString = useDebounce(string, 200)

  const { brands, providers } = useSelector(reduxState => reduxState.entities)

  const entityParams = brand_id
    ? { brand_id, provider_ids: selectedEntityIds }
    : { brand_ids: selectedEntityIds, provider_id }

  return {
    brand,
    brands,
    callbacks: {
      bulkCreateBrandProviders,
      setSelectedEntityIds,
      setState,
    },
    creating,
    debouncedString,
    entityParams,
    provider,
    providers,
    saveEnabled: (brand_id || provider_id) && !!selectedEntityIds.length,
    selectedEntityIds,
    string,
  }
}

export default useBulkCreateBrandProviderModal
